import React from 'react'
import { connect } from "react-redux"
import ReactGA from 'react-ga';
import ScrollspyNav from "react-scrollspy-nav";
import { Form } from 'react-form'
import { Messages } from 'primereact/messages'

import CandidateDetails from '../components/candidate/candidate-details'
import CandidateActions from './CandidateActions'
import ChangePassword from '../components/common/ChangePasswordSection'
import { ROLE_ADMIN, ROLE_GOVERNMENT } from '../js/const'
import { downloadFile } from '../js/file'
import * as appActionCreators from "../actionCreators/app"
import * as authActionCreators from "../actionCreators/auth"
import * as candidateActionCreators from "../actionCreators/candidate"
import * as lookupCodeActionCreators from "../actionCreators/lookupCode"
import * as systemParameterActionCreators from "../actionCreators/systemParameter";

import '../css/response-display.css'


class Candidate extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // flag stored at container level because we want to know when the container itself has loaded so we can hide/show based on that
      // this way any loading done by child components doesn't cause the container to be hidden
      hasLoaded: false,
      // you flag to determine if candidate is being saved without notifications as the normal save and this save uses the same form but does different things
      isSavingWithoutNotification: false,
      filteredSkills: [],
      selectedSkills: [],
      filteredQualifications: [],
      selectedQualifications: [],
      showSkillsHelpText: false,
      showQualificationsHelpText: false,
      showTitleHelpText: false,
      showLinkedInHelpText: false,
      showAnyCommentsHelpText: false,
      showBoardExpirience: true,
      showCommunicationsHelpText: false,
      qualificationsHelpTextToShow: '',
      skillsExpertiseHelpTextToShow: '',
      addedBoards: [],
      isIE: false
    }
    this.updateCandidateBoards = this.updateCandidateBoards.bind(this);
    this.hashLinkScroll = this.hashLinkScroll.bind(this);
    this.cvUpload = React.createRef();
    this.GivenName = React.createRef();
  }

  componentDidMount() {
    document.title = "Candidate - BoardingCall - South Australian Government Boards and Committees";
    // is invoked immediately after a component is mounted. 
    // Initialization that requires DOM nodes should go here. If you need to load data from a remote endpoint, this is a good place to instantiate the network request.   
    this.loadCandidate(this.props.match.params.candidateId)

    //check the browser version and type in use.
    var ua = window.navigator.userAgent;
    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
      this.setState({ isIE: true });
    }
    
    this.initializeReactGA();
  }

  initializeReactGA() {
    ReactGA.initialize(this.props.systemParameter.googleAnalyticsTrackingCode);
    ReactGA.pageview(window.location.pathname + 'candidate');
  }

  componentDidUpdate(prevProps) {
    let previousCandidateId = prevProps.match.params.candidateId
    let candidateId = this.props.match.params.candidateId

    // reload candidate if parameter has changed
    if (previousCandidateId !== candidateId) {
      this.loadCandidate(candidateId)
    }
    if (this.state.hasLoaded) {
      window.scrollBy(0, 1);
    }

    let autocompleteSkillsInput = document.querySelector('#bc-skills-or-expertise .p-autocomplete-input-token input');
    if (autocompleteSkillsInput)
    {
      autocompleteSkillsInput.ariaLabel = "Skills or Expertise - Start typing to choose from available skills in the drop-down list below";
    }

    let autocompleteQualificationsInput = document.querySelector('#bc-qualifications .p-autocomplete-input-token input');
    if (autocompleteQualificationsInput)
    {
      autocompleteQualificationsInput.ariaLabel = "Qualifications - Start typing to choose from available qualifications in the drop-down list below";
    }

  }

  loadCandidate = candidateId => {
    //is invoked immediately after a component is mounted. 
    //Initialization that requires DOM nodes should go here. If you need to load data from a remote endpoint, this is a good place to instantiate the network request.   
    this.props.setLoading(true)
      .then(() => {
        return Promise.all([
            this.props.getCandidate(candidateId),
            this.loadLookupCodes(),
            this.props.getCandidateDetailsIntroText(),
            this.props.getStateGovtEmployeeLink(),
            this.props.getQualificationsHelpText(),
            this.props.getSkillsExpertiseHelpText(),
            this.props.getDeclarationBodyText(),
            this.props.getTitleHelpText(),
            this.props.getLinkedInLinkHelpText(),
            this.props.getAnyCommentsHelpText(),
            this.props.getCommunicationsHelpText()
          ])
      })
      .then(() => {
        // check if current candidate that is being looked at exists. If not create an empty object to deal with issues that could be caused by candidate being undefined
        let currentCandidate = this.props.candidate.currentCandidate ? this.props.candidate.currentCandidate : {}
        let skills = currentCandidate.SkillLookups ? currentCandidate.SkillLookups.$values : []
        let qualifications = currentCandidate.QualificationLookups ? currentCandidate.QualificationLookups.$values : []
        let candidateBoards = currentCandidate.CandidateBoards ? currentCandidate.CandidateBoards.$values : []
        let boardExpirience = currentCandidate.BoardExpirenceFlag ? currentCandidate.BoardExpirenceFlag : false
        this.setState({ selectedSkills: skills, selectedQualifications: qualifications, addedBoards: candidateBoards, showBoardExpirience: boardExpirience })
      })
      .then(() => this.props.setLoading(false))
      .then(() => this.setState({ hasLoaded: true }))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          this.props.history.push('/error/401')
          this.props.setLoading(false)
        } else {
          this.props.handleError(error)
            .then(() => this.props.setLoading(false))
            .then(() => this.setState({ hasLoaded: true }))
        }
      });
  }

  loadLookupCodes = () => {
    let currentCandidate = this.props.candidate.currentCandidate ? this.props.candidate.currentCandidate : {}
    let selectedSkillLovIds = []
    if (currentCandidate.SkillLookups) {
      selectedSkillLovIds = currentCandidate.SkillLookups.$values.map(skillLookup => skillLookup.CodeLovId)
    }
    let selectedQualificationLovIds = []
    if (currentCandidate.QualificationLookups) {
      selectedQualificationLovIds = currentCandidate.QualificationLookups.$values.map(qualificationLookup => qualificationLookup.CodeLovId)
    }

    let selectedGenderLovIds = []
    if (currentCandidate.GenderLookup) {
      selectedGenderLovIds = [currentCandidate.GenderLookup.CodeLovId]
    }

    // load lookup codes for drop downs
    let dataloadPromises = []
    dataloadPromises.push(this.props.getQualifications(true, selectedQualificationLovIds))
    dataloadPromises.push(this.props.getGenders(true, selectedGenderLovIds))
    dataloadPromises.push(this.props.getSkills(true, selectedSkillLovIds))
    return Promise.all(dataloadPromises)
  }

  setIsSavingWithoutNotification= isSavingWithoutNotification => this.setState({ isSavingWithoutNotification: isSavingWithoutNotification })

  // this function will be called when the form is submitted successfully
  // the candidate object passed is in the same structure as the object bound to <Form> values property
  // the object will have been updated based on user input
  formSubmittedSuccessfully = candidate => {
    // convert date of birth to date so we handle correctly for things such as UTC and format
    candidate.DateOfBirth = candidate.DateOfBirth ? new Date(candidate.DateOfBirth) : null

    // depending on the type of employee stat dec might not be available
    if (this.cvUpload && this.cvUpload.current) {
      let files = this.cvUpload.current.files
      if (files && files.length > 0) {
        let cv = files[0]
        candidate.CandidateCv = cv
        candidate.CandidateCvFileName = cv.name
      }
    }

    candidate.IsSavingWithoutNotification = this.state.isSavingWithoutNotification
    this.saveCandidate(candidate)
  }

  formFailedSubmission = (errors, onSubmitError, formApi) => {
    //let validationErrors = <ul>{Object.entries(errors).map(([key, value]) => <li key={key} id={key}>{value}</li>)}</ul>
       
    //window.scrollTo(0, 0);
    //this.messages.clear();
    //this.messages.show({ severity: 'error', detail: validationErrors, life: 3000 });

    if (Object.keys(errors).length > 0)
    {
      let firstErrorObjectId = Object.keys(errors)[0];
      console.log(firstErrorObjectId);
      if (firstErrorObjectId)
      {
        var element = document.querySelector('#' + firstErrorObjectId);
        if (element)
        {
          if (element.tagName.toLowerCase() === "div" || element.tagName.toLowerCase() === "span")
          {
            element = document.querySelector('#' + firstErrorObjectId + ' input');
          }
          if (element)
          {
            element.focus();
          }
        }
      }
    }
  }

  saveCandidate = candidate => {
    candidate.SkillLookups = this.state.selectedSkills
    candidate.QualificationLookups = this.state.selectedQualifications
    candidate.CandidateBoards = this.state.addedBoards
    candidate.BoardExpirenceFlag = this.state.addedBoards.length > 0 ? true : false
    this.props.setLoading(true)
      .then(() => {
        if (candidate.CandidateId) {
          // second step is candidate being updated
          this.props.updateCandidate(candidate)
            .then(response => {
              // set response in store so global response component can handle response
              this.props.setAjaxResponse(response)
              if (response.data.Success) {
                this.clearCv()
                this.loadLookupCodes()
                .then(() => this.props.setLoading(false))
              } else {
                this.props.setLoading(false)
              }
            })
            .catch((error) => this.props.handleError(error)
              .then(() => this.props.setLoading(false)))
        } else {
          // get username and password so we can create an account and login when successfully registered
          let accountDetails = { Username: candidate.Email, Password: candidate.NewPassword }
          // first step is candidate being registered
          this.props.addCandidate(candidate)
            .then(response => {
              // set response in store so global response component can handle response
              /*
                  response json structure is:
                  {
                      "$id":"1",
                      "SuccessOutput":null,
                      "Success":false,
                      "ErrorMessages":{
                          "$id":"2",
                          "$values":[
                              "Name is required"
                          ]
                      },
                      "WarningMessages":{
                          "$id":"3",
                          "$values":[

                          ]
                      }
                  }
              */
              this.props.setAjaxResponse(response)
              if (response.data.Success) {
                this.clearCv()
                let addResponse = response
                // candidate has successfully registered so login and take them to their page
                if (response.data.Login)
                {
                  this.props.performLogin(accountDetails)
                  .then(response => {
                    if (response.data.access_token) {
                      this.props.history.push('/candidate/' + addResponse.data.SuccessOutput.CandidateId)
                      window.scrollTo(0, 0)
                    }
                    this.props.setLoading(false)
                  })
                  .catch((error) => this.props.handleError(error)
                    .then(() => this.props.setLoading(false)))
                }
                else
                {
                  this.props.history.push('/')
                }
                
              }
              this.props.setLoading(false)
            })
            .catch((error) => this.props.handleError(error)
              .then(() => this.props.setLoading(false)))
        }
      })
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  clearCv = () => {
    // clear any file that had been selected so next time dialog is open it will be in the default state
    // this will be undefined if viewing in read only mode
    if (this.cvUpload && this.cvUpload.current) {
      this.cvUpload.current.clear()
    }
  }

  downloadCv = (e, candidateId) => {
    e.preventDefault()
    if (candidateId) {
      // show loading icon since we are doing an ajax call
      this.props.setLoading(true)
        .then(() => this.props.getCandidateCv(candidateId))
        .then((response) => {
          var fileData = new Blob([response.data])

          // get filename from the content disposition header that is set server side
          let contentDisposition = response.headers['content-disposition']
          let filename = contentDisposition.substring(contentDisposition.indexOf('=') + 1)
          downloadFile(fileData, filename)

          this.props.setLoading(false)
        })
        .catch((error) => this.props.handleError(error)
          .then(() => this.props.setLoading(false)))
    }
  }

  removeCv = (e, candidateId) => {     
    if (candidateId) {
      // show loading icon since we are doing an ajax call
      this.props.setLoading(true)
        .then(() => this.props.removeCandidateCv(candidateId))
        .then((response) => {          
          this.props.setLoading(false)
        })
        .catch((error) => this.props.handleError(error)
          .then(() => this.props.setLoading(false)))
    }
  }

  filterSkills = e => {
    setTimeout(() => {
      let results = this.props.lookupCode.skills.filter(skill => {
        return skill.Description.toLowerCase().startsWith(e.query.toLowerCase());
      })

      this.setState({ filteredSkills: results })
    }, 250)
  }

  setSkills = e => {
    let isGovernment = this.props.auth.roles && this.props.auth.roles.some(role => role === ROLE_GOVERNMENT)
    if (isGovernment === false) {
      this.setState({ selectedSkills: e.value })
    }
  }

  filterQualifications = e => {
    setTimeout(() => {
      let results = this.props.lookupCode.qualifications.filter(qualification => {
        return qualification.Description.toLowerCase().startsWith(e.query.toLowerCase());
      })

      this.setState({ filteredQualifications: results })
    }, 250)
  }

  setQualifications = e => {
    let isGovernment = this.props.auth.roles && this.props.auth.roles.some(role => role === ROLE_GOVERNMENT)
    if (isGovernment === false) {
      this.setState({ selectedQualifications: e.value })
    }
  }

  updateCandidateBoards(candidateBoards) {
    this.setState({ addedBoards: candidateBoards })
  }

  showHelpText = (e, section) => {
    e.preventDefault()
    if (e.target.parentElement.getAttribute('aria-expanded') == 'false')
    {
      e.target.parentElement.setAttribute('aria-expanded', 'true');
    }
    else
    {
      e.target.parentElement.setAttribute('aria-expanded', 'false');
    }
    if (section === 'SKILLS') {
      this.setState({
        showSkillsHelpText: this.state.showSkillsHelpText ? false : true,
      });
      var nextSpan = e.target.nextSibling;
      if (nextSpan)
      {
        nextSpan.textContent="Skills - more information";
      }
    }
    if (section === 'QUALIFICATIONS') {
      this.setState({
        showQualificationsHelpText: this.state.showQualificationsHelpText ? false : true,
      });
      var nextSpan = e.target.nextSibling;
      if (nextSpan)
      {
        nextSpan.textContent="Qualifications - more information";
      }
    }
    if (section === 'TITLE') {
      this.setState({
        showTitleHelpText: this.state.showTitleHelpText ? false : true,
      });
      var nextSpan = e.target.nextSibling;
      if (nextSpan)
      {
        nextSpan.textContent="Title - more information";
      }
    }
    if (section === 'LINKEDINURL') {
      this.setState({
        showLinkedInHelpText: this.state.showLinkedInHelpText ? false : true,
      });
      var nextSpan = e.target.nextSibling;
      if (nextSpan)
      {
        nextSpan.textContent="LinkedIn url - more information";
      }
    }
    if (section === 'ANYCOMMENTS') {
      this.setState({
        showAnyCommentsHelpText: this.state.showAnyCommentsHelpText ? false : true,
      });
      var nextSpan = e.target.nextSibling;
      if (nextSpan)
      {
        nextSpan.textContent="Any comments - more information";
      }
    }

    if (section === 'COMMUNICATIONS') {
      this.setState({
        showCommunicationsHelpText: this.state.showCommunicationsHelpText ? false : true,
      });
      var nextSpan = e.target.nextSibling;
      if (nextSpan)
      {
        nextSpan.textContent="Communications - more information";
      }
    }



    if (section === 'BOARDEXPIRIENCE') {
      // let countOfBoardEntries =  this.props.candidate.currentCandidate.CandidateBoards? this.props.candidate.currentCandidate.CandidateBoards.$values.length : 0
      let countOfBoardEntries = this.state.addedBoards ? this.state.addedBoards.length : 0
      // if we have no board entires allow the check box to be checked and unchecked (toggled)
      let isShowBoardExprirence = this.state.showBoardExpirience ? false : true;

      if (countOfBoardEntries > 0) {
        //We have board entiries so the use is not allowed to hide this section
        isShowBoardExprirence = true;
      }

      this.setState({
        showBoardExpirience: isShowBoardExprirence
      });

      var nextSpan = e.target.nextSibling;
      if (nextSpan)
      {
        nextSpan.textContent="Board experience - more information";
      }

    }
  }
  setDisabled = e => {
    this.setDisabled = true;
  }

  hashLinkScroll = (section) => {
    // const { hash } = window.location;
    //section = 'loginSection'
    if (section) {
      // Push onto callback queue so it runs after the DOM is updated,
      // this is required when navigating from a different page so that
      // the element is rendered on the page before trying to getElementById.
      setTimeout(() => {
        const id = section.replace('#', '');
        const element = document.getElementById(id);
        // if (element) //element.scrollIntoView(true);
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        window.scrollBy(0, -200);

      }, 0);
    }
  }

  render() {
    // check if current candidate that is being looked at exists. If not create an empty object to deal with issues that could be caused by candidate being undefined
    let currentCandidate = this.props.candidate.currentCandidate ? this.props.candidate.currentCandidate : {}
    let validationRules = currentCandidate.ValidationRules ? currentCandidate.ValidationRules.$values : []

    let candidateDetailsIntroText = this.props.systemParameter.candidateDetailsIntroText ? this.props.systemParameter.candidateDetailsIntroText : ''
    let stateGovtEmployeeLink = this.props.systemParameter.stateGovtEmployeeLink ? this.props.systemParameter.stateGovtEmployeeLink : ''

    let skillsExpertiseHelpText = this.state.showSkillsHelpText ? this.props.systemParameter.skillsExpertiseHelpText : ''
    let qualificationsHelpText = this.state.showQualificationsHelpText ? this.props.systemParameter.qualificationsHelpText : ''

    //let titleHelpText = this.state.showTitleHelpText ? "<p>i.e. Mr/Ms/Dr/Prof/Rev</p>" : ''
    let titleHelpText = this.state.showTitleHelpText ? this.props.systemParameter.titleHelpText : ''

    //let linkedInHelpText =  this.state.showLinkedInHelpText?  "<p>E.g. LinkedIn or personal website</p>" : ''
    let linkedInHelpText = this.state.showLinkedInHelpText ? this.props.systemParameter.linkedInLinkHelpText : ''

    //let anyCommentsHelpText = this.state.showAnyCommentsHelpText? "<p>Please tell us about yourself. You could make a personal statement, expand on your expertise, or identify any areas of special interest that you think are relevant</p>" :""
    let anyCommentsHelpText = this.state.showAnyCommentsHelpText ? this.props.systemParameter.anyCommentsHelpText : ""

    let declarationText = this.props.systemParameter.declarationBodyText ? this.props.systemParameter.declarationBodyText : ""

    let communicationsHelpText = this.state.showCommunicationsHelpText ? this.props.systemParameter.communicationsHelpText : ""

    let showBoardExpirience = this.state.showBoardExpirience
    let candidateBoards = this.state.addedBoards
    let isAuthenticated = this.props.auth.isAuthenticated
    let isAdd = !currentCandidate.CandidateId
    let isAdmin = this.props.auth.roles && this.props.auth.roles.some(role => role === ROLE_ADMIN)
    let isGovernment = this.props.auth.roles && this.props.auth.roles.some(role => role === ROLE_GOVERNMENT)

    let isCorrectCandidate = currentCandidate.CandidateId === this.props.auth.candidateId

    let canSave = (isAdd === false && isAuthenticated === true && (isAdmin === true || isCorrectCandidate)) || isAdd

    let skillsAutocomplete = {
      values: this.state.selectedSkills,
      filteredOptions: this.state.filteredSkills,
      filterMethod: this.filterSkills,
      onChange: this.setSkills
    }

    let qualificationsAutocomplete = {
      values: this.state.selectedQualifications,
      filteredOptions: this.state.filteredQualifications,
      filterMethod: this.filterQualifications,
      onChange: this.setQualifications
    }
    
    let sideNavItems = [
      <li key={'personalDetails'}><a  href="#personalDetails"><span  > Personal Details</span></a></li>,
      <li key={'contactInformation'}><a   href="#contactInformation"><span>Contact Information</span></a></li>,
      <li key={'employmentDetails'}><a   href="#employmentDetails"><span >Employment Details</span></a></li>,
      <li key={'skillsAndQualifications'}><a    href="#skillsAndQualifications"><span>Skills and Qualifications</span></a></li>,
    ]
 

    let scrollTargetIds = [
      "personalDetails",
      "contactInformation",
      "employmentDetails",
      "skillsAndQualifications",
    ]

    isAdd === true && scrollTargetIds.push("loginSection")
    isAdd === true && sideNavItems.push(<li key={'loginSection'}><a href="#loginSection"><span>Login Details</span></a></li>)
    isAdd === false && (isAdmin === true || isGovernment === true) && scrollTargetIds.push("communicationsSection")
    isAdd === false && (isAdmin === true || isGovernment === true) && sideNavItems.push(<li key={'communicationsSection'}><a href="#communicationsSection"><span>Record of Communications</span></a></li>)
    isAdd === false && isAdmin === true && scrollTargetIds.push("rejectSection")
    isAdd === false && isAdmin === true && sideNavItems.push(<li key={'rejectSection'}><a href="#rejectSection"><span>Reject Reason</span></a></li>)
    isAdd === true && scrollTargetIds.push("declarationSection")
    isAdd === true && sideNavItems.push(<li key={'declarationSection'}><a href="#declarationSection"><span>Declaration</span></a></li>)
    isAdd === false && isAdmin === true && scrollTargetIds.push("changePasswordSection")
    isAdd === false && isAdmin === true && sideNavItems.push(<li key={'changePasswordSection'}><a href="#changePasswordSection"><span>Change Password</span></a></li>)
    isAdd === false && scrollTargetIds.push("confirmChanges")
    isAdd === false && sideNavItems.push(<li key={'confirmChanges'}><a href="#confirmChanges"><span>Confirm Changes</span></a></li>)

    return (
      <React.Fragment>
        {/* values sets the form state. I'm binding to the props which is linked redux so we can update the store and the form will be reflected
                   this is useful when needed to clear the form or populating the form from another component
                   onSubmit is called when the form has been submitted and has passed validation
                   formApi properties can be found at https://react-form.js.org/#/*/}
        <Form values={currentCandidate} onSubmit={this.formSubmittedSuccessfully} onSubmitFailure={this.formFailedSubmission}>
          {formApi => {
            return (
              <div className="p-grid">

                <div className="sidenav p-col-12 p-md-3" >

                  {this.state.hasLoaded && !this.state.isIE && <ScrollspyNav
                    scrollTargetIds={scrollTargetIds}
                    activeNavClass="is-active"
                    scrollDuration="0"
                    headerBackground="true"
                    router="Routes"
                  >
                    <ul>
                    {sideNavItems}
                    </ul>
                  </ScrollspyNav>}
                  {this.state.hasLoaded && this.state.isIE && <span>
                    <ul>
                    <li><a  onClick={() => this.hashLinkScroll('personalDetails')}  >Personal Details</a></li>
                    <li><a  onClick={() => this.hashLinkScroll('contactInformation')}  >Contact Information</a></li>
                    <li><a  onClick={() => this.hashLinkScroll('employmentDetails')}  >Employment Details</a></li>
                    <li><a  onClick={() => this.hashLinkScroll('skillsAndQualifications')}  >Skills And Qualifications</a></li>
                    {isAdd === true && <li> <a onClick={() => this.hashLinkScroll('loginSection')}><span>Login Details</span></a></li>}
                    {isAdd === false && (isAdmin === true || isGovernment === true) && <li><a onClick={() => this.hashLinkScroll('communicationsSection')}><span>Record of Communications</span></a></li>}
                    {isAdd === false && isAdmin === true && <li><a onClick={() => this.hashLinkScroll('rejectSection')}><span>Reject Reason</span></a></li>}
                    {isAdd === true && <li><a onClick={() => this.hashLinkScroll('declarationSection')}><span>Declaration</span></a></li>}
                    {isAdd === false && isAdmin === true && <li><a onClick={() => this.hashLinkScroll('changePasswordSection')}><span>Change Password</span></a></li>}
                    {isAdd === false && <li><a onClick={() => this.hashLinkScroll('confirmChanges')}><span>Confirm Changes</span></a></li>}
                    </ul>
                  </span>}

                </div>



                <div className="candidate-details p-col-12 p-md-9">

                  <Messages className={"response-message"} ref={(el) => this.messages = el} />

                  {this.state.hasLoaded && <CandidateDetails currentCandidate={currentCandidate} canSave={canSave} cvUpload={this.cvUpload} downloadCv={this.downloadCv} removeCv={this.removeCv}
                    genders={this.props.lookupCode.genders} qualificationsAutocomplete={qualificationsAutocomplete} skillsAutocomplete={skillsAutocomplete} isAdmin={isAdmin}
                    isGovernment={isGovernment} candidateDetailsIntroText={candidateDetailsIntroText} stateGovtEmployeeLink={stateGovtEmployeeLink}
                    qualificationsHelpText={qualificationsHelpText} skillsExpertiseHelpText={skillsExpertiseHelpText} titleHelpText={titleHelpText} showHelpText={this.showHelpText}
                    candidateBoards={candidateBoards} updateCandidateBoards={this.updateCandidateBoards} showBoardExpirience={showBoardExpirience}
                    linkedInHelpText={linkedInHelpText} anyCommentsHelpText={anyCommentsHelpText} declarationText={declarationText} communicationsHelpText={communicationsHelpText} />}
                  {this.state.hasLoaded && isAdd === false && isAdmin === true && <ChangePassword validationRules={validationRules} isAdmin={isAdmin} />}
                  {this.state.hasLoaded && <CandidateActions formApi={formApi} setIsSavingWithoutNotification={this.setIsSavingWithoutNotification} />}
                </div>
              </div>
            )
          }
          }
        </Form>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return state
}

// this is how to combine actions available
const actionCreators = {
  ...appActionCreators,
  ...authActionCreators,
  ...candidateActionCreators,
  ...lookupCodeActionCreators,
  ...systemParameterActionCreators
}

export default connect(mapStateToProps, actionCreators)(Candidate);


// WEBPACK FOOTER //
// ./src/container/Candidate.js